import { render, staticRenderFns } from "./SpareParts.vue?vue&type=template&id=1f94c292"
import script from "./SpareParts.vue?vue&type=script&lang=js"
export * from "./SpareParts.vue?vue&type=script&lang=js"
import style0 from "./SpareParts.vue?vue&type=style&index=0&id=1f94c292&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports